"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEstimatedShippingCost = getEstimatedShippingCost;
const find_best_priced_solution_1 = require("../find-best-priced-solution");
function getEstimatedShippingCost(
// eslint-disable-next-line @typescript-eslint/no-unused-vars
lineItemPackagingCriteria) {
    const { bestPricedLogisticSplit } = (0, find_best_priced_solution_1.findBestPricedSolution)(lineItemPackagingCriteria);
    return {
        estimatedShippingCost: bestPricedLogisticSplit.totalLogisticCost,
        split: bestPricedLogisticSplit.logisticOrders.map(({ shippingCostWithoutDiscount, shippingDiscount, lines, ...logisticOrder }) => ({
            estimatedSplitShippingCost: computeShippingCost(shippingCostWithoutDiscount, shippingDiscount),
            lines: lines.map(line => ({
                lineId: line.lineId,
                selectedLogisticOffer: line.selectedLogisticOffer,
                quantity: line.quantity,
                weightInGrams: line.weightInGrams,
                dimensions: line.dimensions
            })),
            ...logisticOrder
        }))
    };
}
function computeShippingCost(shippingCostWithoutDiscount, shippingDiscount) {
    return (+shippingCostWithoutDiscount - +shippingDiscount).toString();
}
